import React, { FC, PointerEventHandler } from 'react';
import cn from 'classnames';
import { Icon, IIconProps } from '../../Icon/Icon';
import { Button, ButtonThemes, IButtonProps, ButtonSizes } from '../../Button';
require("./TextInput-Clear.css");
var styles = {
  "Root": "TextInput-Clear-module-Root_3wV",
  "visible": "TextInput-Clear-module-visible_2sY",
  "disabled": "TextInput-Clear-module-disabled_35k"
};
export const TextInputClear = ({
  visible,
  disabled,
  className,
  size,
  onPointerDown
}) => /*#__PURE__*/React.createElement(Button, {
  theme: ButtonThemes.transparent,
  size: ButtonSizes.s,
  className: cn(styles.Root, {
    [styles.visible]: visible,
    [styles.disabled]: disabled
  }, className),
  onPointerDown: onPointerDown
}, /*#__PURE__*/React.createElement(Icon, {
  name: "close",
  size: size
}));